// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .protections-and-options-widget--hako5{border:2px solid #ddd;background-color:#fff;text-align:center}", ""]);
// Exports
exports.locals = {
	"protectionsAndOptionsWidget": "protections-and-options-widget--hako5"
};
module.exports = exports;
